export default "__VITE_ASSET__CVn$Vp$F__"